import { render, staticRenderFns } from "./submit.vue?vue&type=template&id=6e12d4d1&"
import script from "./submit.vue?vue&type=script&lang=js&"
export * from "./submit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/site-front-pipline/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e12d4d1')) {
      api.createRecord('6e12d4d1', component.options)
    } else {
      api.reload('6e12d4d1', component.options)
    }
    module.hot.accept("./submit.vue?vue&type=template&id=6e12d4d1&", function () {
      api.rerender('6e12d4d1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/workplace/PL/components/submit.vue"
export default component.exports